import React, {useContext} from "react";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import "./ProjectVideo.scss";

const items = [
  {
    id: "mico",
    heading: "See it in action",
    subtitle: "Microsoft Copilot · mico voice",
    src: require("../../assets/videos/microsoft_mico.mp4"),
    orientation: "portrait"
  }
  // {
  //   id: "openforge",
  //   heading: "openForge",
  //   subtitle: "\u201CForge work with agents\u201D",
  //   src: require("../../assets/videos/openforge.mp4"),
  //   orientation: "landscape"
  // }
];

export default function ProjectVideo() {
  const {isDark} = useContext(StyleContext);
  return (
    <div className={isDark ? "dark-mode main" : "main"} id="project-video">
      {items.map(item => (
        <Fade bottom duration={1000} distance="20px" key={item.id}>
          <div className="project-video-main">
            <h1
              className={
                isDark
                  ? "dark-mode project-video-heading"
                  : "project-video-heading"
              }
            >
              {item.heading}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle project-video-subtitle"
                  : "subTitle project-video-subtitle"
              }
            >
              {item.subtitle}
            </p>
            <div className={`project-video-frame ${item.orientation}`}>
              <video
                className={`project-video-el ${item.orientation}`}
                src={item.src}
                controls
                playsInline
                muted
                loop
                preload="metadata"
              />
            </div>
          </div>
        </Fade>
      ))}
    </div>
  );
}
